<template>
  <div id="app">
    <Register v-if="isRegister"></Register>
    <Forget v-if="isForget"></Forget>
    <Login v-if="isLogin"></Login>
    <SclUserLogin v-if="isUserLogin"></SclUserLogin>
    <Vip v-if="isShowVip"></Vip>
    <Activation v-if="isShowAddVip"></Activation> 
    <Information v-if="isShowGk"></Information>
    <Save v-if="isShowPlan"></Save>
    <UpdateUserName v-if="isShowUserName"></UpdateUserName>
    <CompareSchool v-if="isCompare"></CompareSchool>
    <Province v-if="isProvince"></Province>
    <WechatPay v-if="isWechatPay"></WechatPay>
    <keep-alive :include="['layout']">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
	<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getQuery } from '@/utils/auth'
import { getWebsite, getArea } from '@/api/home'

export default {
  name: 'app',
  data() {
    return {
      areaInfo: {}
    }
  },
  computed: {
    ...mapState({
        isUserLogin: state => state.user.isUserLogin,
        isLogin: state => state.user.isLogin,
        isShowGk: state => state.user.isShowGk,
        isShowVip: state => state.user.isShowVip,
        isVipStr: state => state.user.isVipStr,
        isShowAddVip: state => state.user.isShowAddVip,
        isShowPlan: state => state.user.isShowPlan,
        isShowUserName: state => state.user.isShowUserName,
        isRegister: state => state.user.isRegister,
        isForget: state => state.user.isForget,
        isProvince: state => state.user.isProvince,
        isCompare: state => state.user.isCompare,
        isWechatPay: state => state.user.isWechatPay,
        token: state => state.user.token,
        provinceCode: state => state.user.provinceCode,
        localTypeId: state => state.user.localTypeId
      })
    },
    watch: {
      provinceCode() {
        this.handleChangeArea()
      },
      localTypeId() {
        this.handleChangeArea()
      }
    },
  async created() {
    const params = getQuery()
    this.getWebsite()
    this.getAreaHandler()
    
  },
  methods: {
    getWebsite() {
      const domain = window.location.hostname
      // const domain = 'lizhishengya.com'
      getWebsite(domain).then(res => {
        this.$store.commit('user/CHANGEWEB',  res.data);
        const favicon = document.querySelector('link[rel="icon"]');
        const timestamp = new Date().getTime(); // 获取当前时间戳
        favicon.href = `${process.env.VUE_APP_FILE_API}${res.data.favicon}?t=${timestamp}`;
        document.title = res.data.name
      }).catch(() => {
        const data = {
          name: '荔枝生涯',
          logo_top: '',
          logo_bottom: '',
          favicon: '',
        }
        this.$store.commit('user/CHANGEWEB',  data);
      })
    },
    getAreaHandler() {
      const params = getQuery()
      let year = new Date().getFullYear()
      if(new Date().getMonth() > 7) {
        year = (new Date().getFullYear()) + 1
      }
      if(localStorage.getItem("gk_year")) {
        year = localStorage.getItem("gk_year")
      }
      getArea(year).then(res => {
        sessionStorage.setItem('proInfo', JSON.stringify(res.data))
        this.areaInfo = res.data
        this.handleChangeArea()
        if(params.token) {
          this.$store.commit('user/LOGINSTATUS', false);
          localStorage.setItem("hasLogin",'false');
          this.$store.commit('user/GETINFOR');
          if(!params.area) {
              if(!params.local_type_id) {
                  this.$store.commit('user/SHOWPROVINCE', true);
              } else {
                this.$store.commit('user/SAVEAREA');
              }
          } else {
              if(!params.local_type_id) {
                  this.$store.commit('user/SHOWPROVINCE', true);
              } else {
                  localStorage.setItem("area", params.area);
                  this.$store.commit('user/CHANGEPROVINCE',  params.area);
                  this.$store.commit('user/CHANGELOCALTYPEID', params.local_type_id);
              }
          }
        }
        if(!this.token) {
            this.$store.commit('user/SHOWPROVINCE', true);
            // localStorage.removeItem("area");
            localStorage.removeItem("localTypeId");
        }
      })
    },
    handleChangeArea() {
      const tmp = this.areaInfo.filter(val => { return val.area === this.provinceCode})
      const batchList = tmp[0].local_batch_id
      const subjectList = tmp[0].local_type_id
			const subjectObj = {}
      const batchObj = {}
      subjectList.map(item => {
        subjectObj[item.local_type] = item
      })
      batchList.map(item => {
        batchObj[item.local_batch_id] = item
      })
      this.$store.commit('user/CHANGPRO', true);
      sessionStorage.setItem('batchObj', JSON.stringify(batchObj))
      sessionStorage.setItem('batchList', JSON.stringify(batchList))
      sessionStorage.setItem('subjectObj', JSON.stringify(subjectObj))
      sessionStorage.setItem('subjectList', JSON.stringify(subjectList))
    }
  }
}
</script>

<style>
#app,html, body {
	min-width: 1370px;
  height: 100%;
  font-family: 'PingFangSC-Regular', 'helvetica neue', tahoma, 'PingFang SC', 'microsoft yahei', arial, 'hiragino sans gb', sans-serif;
  overflow: auto;
}
</style>
